import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import { InputBaseComponent } from 'src/app/inputs/input.base';
import { elementAt } from 'rxjs/operators';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'testo',
  templateUrl: './input-testo.component.html',
  styleUrls: ['./input-testo.component.css']
})
export class InputTestoComponent extends InputBaseComponent implements OnInit {
  @Input() type = 'string';
  internalType = 'text';
  @Input() maxlength: number;
  @Input() noDiv = false;
  @Input() toUpper = false;
  keyPressed = false;
  @Output() inputModelChange = new EventEmitter<string>();
  @Input() inputModel: string;
  @Input() errore: string;
  @ViewChild('inputField') inputField: ElementRef;
  @ViewChild('defaultField') defaultField: ElementRef;
  @ViewChild('deleteAllIcon') deleteAllIcon: ElementRef;

  constructor() {
    super();
  }

  setInputValue(value: any) {
    this.inputModel = value;
  }

  keyUpEvent(ev: KeyboardEvent) {
    const elem = ev.currentTarget as HTMLInputElement;

    switch (this.type) {
      case 'integer':
        elem.value = elem.value.replace(/([^0-9]*)/g, '');
        break;
      case 'testo':
        elem.value = elem.value.replace(/([^a-zA-z ]*)/g, '');
        break;
      case 'decimal':
        elem.value = elem.value.replace(',', '.').replace(/([^0-9.]*)/g, '');
        while (elem.value.split('.').length > 2) {
          elem.value = elem.value.substring(0, elem.value.lastIndexOf('.'));
        }
        break;
      case 'date':
        if ((elem.value.length === 2 || elem.value.length === 5) && ev.key !== 'Backspace') {
          elem.value = elem.value.concat('/');
        }
        break;
      case 'email':
        const color: string =
          elem.value.match(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i) != null ? 'black' : 'red';
        elem.style.color = color;
        break;
      /* case 'currency':

          if ((/^[0-9]+(\,|\.)?[0-9]{1,2}?(\€)?$/).test(elem.value)) {
            let importo = elem.value.replace('.', ',');
            elem.value = importo;
          }
          break;*/
      default:
        break;
    }

    if (this.toUpper) {
      elem.value = elem.value.toLocaleUpperCase();
    }

    this.keyPressed = false;
  }

  keyDownEvent(ev: KeyboardEvent) {
    const elem = ev.currentTarget as HTMLInputElement;
    const key: string = ev.key;
    // (<HTMLInputElement>ev.target).value
    if (key === 'Backspace') { return true; }

    switch (this.type) {
      case 'integer':
        if (!/([0-9])/.test(key) && (ev.keyCode === 32 || ev.keyCode > 46)) { ev.preventDefault(); }
        break;
      case 'testo':
        if (!/([a-zA-z])/.test(key) && ev.keyCode > 46) { ev.preventDefault(); }
        break;
      case 'date':
        ev.preventDefault();
        if (this.keyPressed) { break; }
        if (elem.value.length >= Number.parseInt(elem.getAttribute('maxlength'), 10)) { return; }
        const keyNum: number = Number.parseInt(key, 10);
        if (Number.isNaN(keyNum)) { break; }

        let legit = true;
        switch (elem.value.length) {
          case 0:
            legit = keyNum < 4;
            break;
          case 1:
            switch (elem.value.charAt(0)) {
              case '3':
                legit = keyNum < 2;
                break;
              default:
                break;
            }
            break;
          case 3:
            legit = keyNum < 2;
            break;
          case 4:
            switch (elem.value.charAt(3)) {
              case '0':
                legit = keyNum < 10;
                break;
              case '1':
                legit = keyNum < 3;
            }
            break;
          default:
            break;
        }
        if (legit) {
          elem.value = elem.value.concat(keyNum.toString());
        }
        break;
      default:
        break;
    }
    this.keyPressed = true;
  }

  deleteText() {
    (this.inputField.nativeElement as HTMLInputElement).value = '';
  }

  ngOnInit() {
    this.id = this.id || null;
    if (this.label) {
      this.placeholder = this.placeholder || this.label + '...';
    } else {
      this.placeholder = this.placeholder;
    }
    this.maxlength = Number(this.maxlength) || (this.type === 'date' ? 10 : 1024);
    if (this.inputField) {
      this.inputField.nativeElement.value = this.defaultField.nativeElement.innerHTML;
    }
    if (this.type === 'email') {
      this.internalType = 'email';
    }

    const comp = this;
    // tslint:disable-next-line: no-shadowed-variable
    $(document).ready(($) => {
      comp.keyPressed = false;
      if (this.inputField) {
        $(this.inputField.nativeElement).on(
          {
            keyup: (ev: KeyboardEvent) => {
              comp.keyUpEvent(ev);
            }, keydown: (ev: KeyboardEvent) => {
              comp.keyDownEvent(ev);
            }
          });
      }
    });
  }
  format(importoEntrante: any) {
    let importo: string;
    let importoFormattazione = '' + (importoEntrante.target as HTMLInputElement).value;
    if ((/^[0-9]+$/).test(importoFormattazione)) {
      importo = importoFormattazione.concat(',00€');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+(\€)$/).test(importoFormattazione)) {
      importo = [importoFormattazione.slice(0, importoFormattazione.indexOf('€')), ',00', importoFormattazione.slice(importoFormattazione.indexOf('€'))].join('');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+(\,|\.)$/).test(importoFormattazione)) {
      importo = importoFormattazione.concat('00€');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+(\,|\.)(\€)$/).test(importoFormattazione)) {
      importo = [importoFormattazione.slice(0, importoFormattazione.indexOf('€')), '00', importoFormattazione.slice(importoFormattazione.indexOf('€'))].join('');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+((\,|\.)[0-9]{1})$/).test(importoFormattazione)) {
      importo = importoFormattazione.replace('.', ',').concat('0€');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+((\,|\.)[0-9]{1})(\€)$/).test(importoFormattazione)) {
      importo = [importoFormattazione.slice(0, importoFormattazione.indexOf('€')), '0', importoFormattazione.slice(importoFormattazione.indexOf('€'))].join('');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+((\,|\.)[0-9]{2})$/).test(importoFormattazione)) {
      importo = importoFormattazione.replace('.', ',').concat('€');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    if ((/^[0-9]+((\,|\.)[0-9]{2})(\€)$/).test(importoFormattazione)) {
      importo = importoFormattazione.replace('.', ',');
      importoFormattazione = importo;
      this.inputModel = importoFormattazione;
      return;
    }
    this.inputModel = '00,00€';
  }
}
